import React, { useEffect, useState } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { Button, Form } from "semantic-ui-react";
import { bindActionCreators, Dispatch } from "redux";
import OktaSignIn from "@okta/okta-signin-widget";

import {
  ALL_REQUESTED_PERMISSIONS,
  CLIENT_ID,
  ISSUER,
  LEGIT_SERVICE_CONFIG,
  OKTA_DOMAIN,
  REDIRECT_URI,
  SCOPES,
} from "common";
import { legit } from "apex-legit-service";
import messages from "./messages";
import styles from "./styles.module.scss";
import { RootState } from "StoreTypes";
import { fetchLegacyUrl } from "services/legit/legacyUrl";
import {
  getLoginTypeUrl,
  loginType as loginTypeSelector,
} from "services/legit/loginType";
import {
  createSsoLoginUrl,
  isSsoLoginLoading,
} from "../../services/legit/loginSso";
import "@okta/okta-signin-widget/dist/css/okta-sign-in.min.css";

export interface State extends Record<string, string> {}

export interface Props {
  legacyLogin: (params: State) => void;
  idpCheck: (params: State) => void;
  fetchLegacyUrl: () => void;
  loginType: any;
  ssoLogin: (params: State) => void;
  ssoLoginIsLoading: boolean;
}

const ApexLogin = ({
  legacyLogin,
  fetchLegacyUrl,
  idpCheck,
  loginType,
  ssoLogin,
  ssoLoginIsLoading,
}: Props) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  let loginContainer: any = undefined;
  const { authState } = useOktaAuth();
  const widget = new OktaSignIn({
    baseUrl: `https://${OKTA_DOMAIN}`,
    clientId: CLIENT_ID,
    redirectUri: REDIRECT_URI,
    authParams: {
      issuer: ISSUER,
      pkce: true,
      scope: SCOPES.split(/\s+/),
    },
    colors: {
      brand: "#1C245A",
    },
    username: username,
  });

  useEffect(() => {
    if (loginType.loginType === "OKTA") {
      widget.renderEl({ el: loginContainer });
    } else {
      widget.remove();
    }
  });

  useEffect(() => {
    if (authState.isAuthenticated) {
      ssoLogin({
        idToken: authState.idToken,
        accessToken: authState.accessToken,
      });
      widget.remove();
    }
    //TODO Add call to legit/authorization and lodaing spinner after callback
      // might need to move this logic to App.tsxif
  }, [authState]);

  useEffect(() => {
    fetchLegacyUrl();
  }, []);

  function handleLegacyLogin() {
    legacyLogin({ username: username, password: password });
  }

  function handleIdpCheck() {
    idpCheck({ userName: username });
  }

  const legacyForm = (
    <>
      <Form className={styles.title} onSubmit={handleLegacyLogin}>
        <Form.Input
          value={username}
          label={<FormattedMessage {...messages.username} />}
          onChange={(e) => setUsername(e.currentTarget.value)}
        />
        <Form.Input
          label={<FormattedMessage {...messages.password} />}
          onChange={(e) => setPassword(e.currentTarget.value)}
          type="password"
        />
        <Button type="submit">
          <FormattedMessage {...messages.submit} />
        </Button>
      </Form>
    </>
  );

  return (
    <>
      <div className={styles.loginPanel}>
        {loginType.loginType === "" && (
          <Form
            className={styles.title}
            onSubmit={handleIdpCheck}
            disabled={ssoLoginIsLoading}
          >
            <Form.Input
              value={username}
              label={<FormattedMessage {...messages.username} />}
              onChange={(e) => setUsername(e.currentTarget.value)}
            />
            <Button type="submit">
              <FormattedMessage {...messages.submit} />
            </Button>
          </Form>
        )}
        {loginType.loginType === "LEGACY" && legacyForm}
        {loginType.loginType === "OKTA" && (
          <div
            ref={(div) => {
              loginContainer = div;
            }}
          />
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  isSessionLoading: legit.selectors.isSessionLoading(state),
  loginType: loginTypeSelector(state),
  ssoLoginIsLoading: isSsoLoginLoading(state),
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      legacyLogin: (params) =>
        legit.login(LEGIT_SERVICE_CONFIG, {
          apexUser: true,
          ...params,
          permissions: ALL_REQUESTED_PERMISSIONS,
        }),
      fetchLegacyUrl: fetchLegacyUrl.request,
      idpCheck: (params) => getLoginTypeUrl.request(params),
      ssoLogin: (params) => createSsoLoginUrl.request(params),
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ApexLogin);
